module.exports = "import React from 'react';\n\nconst Example = () => {\n  return (\n    <div className=\"bg-info clearfix\" style={{ padding: '.5rem' }}>\n      <button className=\"btn btn-secondary float-left\">Example Button floated left</button>\n      <button className=\"btn btn-danger float-right\">Example Button floated right</button>\n    </div>\n  );\n};\n\nexport default Example;\n"


//////////////////
// WEBPACK FOOTER
// ./~/raw-loader!./docs/lib/examples/Clearfix.js
// module id = 356
// module chunks = 0